export default "__VITE_ASSET__3bb2c50d__"